export var DropFilterNotificationSubject;
(function (DropFilterNotificationSubject) {
    DropFilterNotificationSubject["SearchFilter"] = "search-filter";
    DropFilterNotificationSubject["CreateFilter"] = "create-filter";
    DropFilterNotificationSubject["UpdateFilter"] = "update-filter";
    DropFilterNotificationSubject["DeleteFilter"] = "delete-filter";
    DropFilterNotificationSubject["ActivateFilter"] = "activate-filter";
    DropFilterNotificationSubject["DeactivateFilter"] = "deactivate-filter";
})(DropFilterNotificationSubject || (DropFilterNotificationSubject = {}));
//# sourceMappingURL=drop-filters.enum.js.map